export class RoleType {
  static ADMIN = "Administrator";
  static MANAGER = "Manager";
  static SALES_MANAGER = "Sales Manager";
  static COMPANY_ADMIN = "Company Admin";
  static COMPANY_USER = "Company User";
  static END_USER = "End User";
}